// extracted by mini-css-extract-plugin
module.exports = {"button":"layout-button_button_osfb1","active":"layout-button_active_K6usb"};